import SpriteSymbol from "../../../../../doctor/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../doctor/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IconExpand",
  "use": "IconExpand-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"IconExpand\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0L24 0 24 24 0 24z\" /><path fill=\"#777\" fill-rule=\"nonzero\" d=\"M12 4L12 6 16.59 6 13.09 9.59 14.5 11 18 7.41 18 12 20 12 20 4z\" /><path fill=\"#777\" fill-rule=\"nonzero\" transform=\"rotate(-180 8 16)\" d=\"M4 12L4 14 8.59 14 4 18.5 5.41 19.91 10 15.41 10 20 12 20 12 12z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol